"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.TableControlItemWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  align-self: center;
  margin: 0 0.5rem;
`;
//# sourceMappingURL=TableControlItemWrapper.js.map